import { useQuery } from '@tanstack/react-query'
import getFeedbackSurveyInfo from '../api/feedback/getFeedbackSurveyInfo'
import { GET_FEEDBACK_SURVEY_KEY } from '../constants'

const useFeedbackSurveyInfo = () => {
  return useQuery([GET_FEEDBACK_SURVEY_KEY], () => {
    return getFeedbackSurveyInfo()
  })
}

export default useFeedbackSurveyInfo
